import React from 'react'
import { Box, Typography } from '@material-ui/core';

const TabPanel = ({ value, index, children, ...other }) => {

  return (
    <>
      <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
       <Box>{children}</Box>
    </Typography>
    </>
  )
}

export default TabPanel